//#region src/media/utils/preload.ts
function isStandardPreload(value) {
	return value === "auto" || value === "metadata" || value === "none";
}
/**
* Default `preload` value used as the fallback across behaviors (`syncPreload`, `resolvePresentation`,
* `isBlockingPreload`). SPF's own default, deliberately independent of the `<video>`/`<audio>` element's implicit
* default — that one is UA policy and browser-dependent (`'metadata'` Chromium, `'auto'` WebKit), never a source.
*/
const DEFAULT_PRELOAD = "metadata";
/**
* True when the preload value blocks initial resolution / loading. Falsy values (undefined, empty) fall back to
* `defaultPreload` (default `DEFAULT_PRELOAD`); the resolved value blocks iff it is `'none'`.
*/
function isBlockingPreload(preload, defaultPreload = DEFAULT_PRELOAD) {
	return (preload || defaultPreload) === "none";
}
//#endregion
export { DEFAULT_PRELOAD, isBlockingPreload, isStandardPreload };
